import { render, staticRenderFns } from "./DuplicateLogsDetails.vue?vue&type=template&id=2b499336&scoped=true"
import script from "./DuplicateLogsDetails.vue?vue&type=script&lang=js"
export * from "./DuplicateLogsDetails.vue?vue&type=script&lang=js"
import style0 from "./DuplicateLogsDetails.vue?vue&type=style&index=0&id=2b499336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b499336",
  null
  
)

export default component.exports